import { useQuery } from "@tanstack/react-query"

import { getHistorial } from "../services/consulta.service";

export const usePacienteConsultaHistorial = (id) => {

    const pacienteConsultaHistorialQuery = useQuery({
        queryKey: ['paciente/consulta/historial', id],
        queryFn: () => getHistorial(id),
        staleTime: 0, // nulo
    });

    return {
        pacienteConsultaHistorialQuery,
    }
}